import { isDevelopment } from './env';

const SIGNUP_PATH = '/account/auth/signup';
const SIGNIN_PATH = '/account/auth/signin';
const PAYMENT_PATH = '/account/me/payment';

const signUpUrl = (redirectUrl: string) => {
  const encodedRedirectUrl = encodeURIComponent(redirectUrl);

  if (isDevelopment()) {
    const { hostname } = window.location;
    return `http://${hostname}:3002${SIGNUP_PATH}?redirect_url=${encodedRedirectUrl}`;
  } else {
    return `${SIGNUP_PATH}?redirect_url=${encodedRedirectUrl}`;
  }
};

const signInUrl = (redirectUrl: string) => {
  const encodedRedirectUrl = encodeURIComponent(redirectUrl);

  if (isDevelopment()) {
    const { hostname } = window.location;
    return `http://${hostname}:3002${SIGNIN_PATH}?redirect_url=${encodedRedirectUrl}`;
  } else {
    return `${SIGNIN_PATH}?redirect_url=${encodedRedirectUrl}`;
  }
};

const paymentUrl = () => {
  if (isDevelopment()) {
    const { hostname } = window.location;
    return `http://${hostname}:3002${PAYMENT_PATH}`;
  } else {
    return PAYMENT_PATH;
  }
};

export { paymentUrl, signInUrl, signUpUrl };
